import React from 'react'

const careers = () => {
  return (

    <div  style={{height:'50vh'}}>
       <h2 className='text-center m-4'>Vacancies</h2> 
       <p className='text-center m-4'> No vacancy available, comeback later</p>
      </div>
  )
}

export default careers